import React, { Component } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { setSelectedLocation } from '../../../actions/search';
import { customSelectStyles, alphabeticallySort } from '../../../utilities/helperUtility';
import Select from '../../../components/Common/Select';
import Translation from '../../../utilities/localizationUtility';
import styled, {css} from 'styled-components';

const LocationSelectWrapper = styled.div`${
  () => {
    return css`
      flex: 2 1 auto;
      min-width: 150px;
      margin: 15px 2px 0 2px;
    }`;
  }
}`;

class Index extends Component {
  onLocationsChange(id) {
    const { locations, setSelectedLocation } = this.props;
    const currentLocation = locations.find(location => location.id === id);
    setSelectedLocation(id === null ? null : currentLocation);
  }

  locationOptions() {
    return alphabeticallySort(this.props.locations, 'name').map(({ id, name }) => ({
      label: name,
      value: id,
    }));
  }

  placeholder() {
    const t = new Translation(this.props);
    return t.key('location') || 'Enter Location';
  }

  render() {
    const { selectedLocation, styles, isDisabled, loading } = this.props,
          locationOptions = this.locationOptions();

    const value = isEmpty(selectedLocation) ? null : selectedLocation.id;

    return (
      <LocationSelectWrapper>
        <Select
          onMenuOpen={this.props.onMenuOpen}
          onMenuClose={this.props.onMenuClose}
          placeholder={this.placeholder()}
          styles={styles}
          value={value}
          options={locationOptions}
          isDisabled={isDisabled}
          isSearchable={true}
          isClearable
          allowSelectOption
          isLoading={loading}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: () => null
          }}
          onChange={x => this.onLocationsChange(x)}
        />
      </LocationSelectWrapper>
    );
  }
}

export default connect(
  ({
    search,
    settings: {
      style = {},
      translation = {},
      defaultTranslation = {}
    }
  }) => ({
    locations: search.locations,
    loading: search.locationLoading,
    selectedLocation: search.selectedLocation,
    styles: customSelectStyles(style.select, false, true),
    translation: translation,
    defaultTranslation: defaultTranslation
  }),
  dispatch => ({
    setSelectedLocation: a => dispatch(setSelectedLocation(a)),
  }),
)(Index);
